import { Component, inject, Input } from '@angular/core';
import { MessageSenderChat, MessageSenderUser, MessageTelegram } from "../../../../types/last-message.types";
import { defaultIcon } from "../../../../configs/telegram-page-config";
import { ChatTelegram } from "../../../../types/chat-telegram.types";
import { TelegramAccountsService } from "../../../../services/telegram-accounts.service";
import { TelegramBloggersService } from "../../../../services/telegram-bloggers.service";
import { TelegramAccountImagesService } from "../../../../services/telegram-account-images.service";
import { TelegramMessageImageComponent } from "../telegram-message-image/telegram-message-image.component";
import { TelegramMessageVideoComponent } from "../telegram-message-video/telegram-message-video.component";
import { TelegramMessageDocumentComponent } from "../telegram-message-document/telegram-message-document.component";
import { TelegramButtonSaveFileComponent } from "../telegram-button-save-file/telegram-button-save-file.component";
import { DatePipe } from "@angular/common";

@Component({
  selector: 'app-telegram-message-card',
  standalone: true,
  imports: [
    TelegramMessageImageComponent,
    TelegramMessageVideoComponent,
    TelegramMessageDocumentComponent,
    TelegramButtonSaveFileComponent,
    DatePipe
  ],
  templateUrl: './telegram-message-card.component.html',
  styleUrls: [
    './telegram-message-card.component.scss',
    '../../telegram-chat-window.component.scss'
  ]
})
export class TelegramMessageCardComponent {
  @Input({ required: true }) message!: MessageTelegram;
  @Input({ required: true }) selectedChat!: ChatTelegram;
  @Input() recordCalendarId: number = 0;

  private telegramAccountsService: TelegramAccountsService = inject(TelegramAccountsService);
  private telegramBloggersService: TelegramBloggersService = inject(TelegramBloggersService);
  private telegramAccountImagesService: TelegramAccountImagesService = inject(TelegramAccountImagesService);

  public getName(messageUser: MessageSenderUser | MessageSenderChat): string {
    if ('userId' in messageUser) {
      if (messageUser.userId === this.selectedChat?.id) {
        return this.selectedChat.title;
      }
    }

    if ('chatId' in messageUser) {
      return messageUser.chatId.toString();
    }

    return this.telegramAccountsService.selectedAccount().accountName;
  }

  public getImage(message: MessageTelegram): string {
    if ('userId' in message.senderId) {
      return message.senderId.userId === this.selectedChat?.id ?
        this.telegramBloggersService.getBloggerImage(message.chatId) :
        this.telegramAccountImagesService.getAccountImage(this.telegramAccountsService.selectedAccount().accountId);
    }

    return defaultIcon;
  }

  public getClassAccount(messageUser: MessageSenderUser | MessageSenderChat): boolean {
    if ('userId' in messageUser) {
      return messageUser.userId !== this.selectedChat?.id;
    }

    if ('chatId' in messageUser) { return false; }

    return false;
  }

  public getReadClass(isRead: boolean | undefined): string {
    return isRead ? 'read-message-icon' : 'no-read-message-icon';
  }
}
